export enum ExchangeRatesEnum {
  fixed = 'FIXED',
}

export enum DocumentVerificationEnum {
  Online = 'ONLINE',
  Branch = 'BRANCH',
}

export enum FlowType {
  Sell = 'SELL',
  Buy = 'BUY',
  SendMoneyAbroad = 'OUTWARD_REMITTANCE',
  UnloadCard = 'CARD_UNLOAD',
  ReloadCard = 'CARD_RELOAD',
  CurrencyRequest = 'CURRENCY_REQUEST',
}

export enum BuyOptions {
  'Forex Card' = 'BUY_CARD',
  'Forex Cash' = 'BUY_CASH',
}

export enum ExchangeRates {
  Fixed = 'FIXED',
  WithMargin = 'WITH_OM_FX_MARGIN',
}

export enum TransactionProcess {
  Online = 'ONLINE',
  Branch = 'BRANCH',
}

export enum DocumentType {
  Aadhaar = 'AADHAAR',
  AddressProof = 'ADDRESS_PROOF',
  Pan = 'PAN',
  Passport = 'PASSPORT',
  Other = 'OTHER',
  AirTicket = 'AIR_TICKET',
  Visa = 'VISA',
  UniversityLetter = 'UNIVERSITY_LETTER',
  HospitalLetter = 'HOSPITAL_LETTER',
  BloodRelation = 'BLOOD_RELATION_PROOF',
  BloodRelationDeclaration = 'BLOOD_RELATION_DECLARATION',
  DebitNote = 'DEBIT_NOTE',
  BankStatement = 'BANK_STATEMENT',
  A2Form = 'A2_FORM',
  Photo = 'PHOTO',
  Unknown = 'UNKNOWN',
  'Voter Card' = 'VOTER_CARD',
  'Driving License' = 'DRIVING_LICENSE',
}

export enum DocumentViewType {
  AadhaarFront = 'AADHAAR_FRONT',
  AadhaarBack = 'AADHAAR_BACK',
  PassportFront = 'PASSPORT_FRONT',
  PassportBack = 'PASSPORT_BACK',
  VoterFront = 'VOTER_CARD_FRONT',
  VoterBack = 'VOTER_CARD_BACK',
  DrivingFront = 'DRIVING_LICENSE_FRONT',
  DrivingBack = 'DRIVING_LICENSE_BACK',
}

export enum AddressProofType {
  'Aadhaar Card' = 'AADHAAR',
  'Voter ID' = 'VOTER_CARD',
  'Passport' = 'PASSPORT',
  'Driving License' = 'DRIVING_LICENSE',
}

export enum UserType {
  Sender = 'SENDER',
  Receiver = 'RECEIVER',
}

export enum FileFormats {
  Pdf = 'PDF',
  Jpeg = 'JPEG',
  Png = 'PNG',
  Jpg = 'JPG',
}

export enum PurposeOfRemittance {
  'Transfer Funds To Family Member Abroad' = 'TRANSFERRING_TO_FAMILY_MEMBER_ABROAD',
  'Transfer Funds To Educational Institute' = 'TRANSFERRING_FOR_EDUCATION_PURPOSE',
  'Medical Visit' = 'TRANSFERRING_FOR_MEDICAL_PURPOSE',
  'Gifts' = 'GIFT',
  'NRE Repatriation' = 'NRE_REPATRIATION',
}

export enum RelationshipWithReceiver {
  'Daughter' = 'DAUGHTER',
  'Son' = 'SON',
  'Father' = 'FATHER',
  'Mother' = 'MOTHER',
  'Brother' = 'BROTHER',
  'Sister' = 'SISTER',
  'Spouse' = 'SPOUSE',
  'Grandparents' = 'GRANDPARENTS',
  'Other Close Relatives' = 'OTHER_CLOSE_RELATIVES',
}

export enum PurposeToBuy {
  'Education Travel' = 'STUDENT',
  'Personal Travel' = 'PRIVATE_VISIT',
  'Business Travel' = 'BUSINESS_VISIT',
  'Medical Travel' = 'MEDICAL',
  'Employment Travel' = 'EMPLOYMENT',
  'Emigration Travel' = 'EMIGRATION',
}

export enum CategoriesForSell {
  'Indian Resident' = 'INDIAN',
  'Non Resident Indian' = 'NON_RESIDENT_INDIAN',
  'Foreigner' = 'FOREIGNER',
}

export enum ReasonForReloadCard {
  'New Trip' = 'NEW',
  'Existing Trip' = 'EXISTING',
}

export enum Countries {
  India = 'INDIA',
  USA = 'USA',
  UK = 'UK',
  Canada = 'CANADA',
}

export enum PaymentMode {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
}

export enum TransactionProcessType {
  Approved = 'APPROVED',
  Processed = 'PROCESSED',
  TransferInitiated = 'TRANSFER_INITIATED',
  Closed = 'CONVERTED',
  Open = 'OPEN',
}
